import {
  Button,
  Fade,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { useAddJawabanQuestionnaire } from "../../../api/effects/mutations/Questionnaire/addJawabanQuestionnaire";
import useFetchQuestionnaire from "../../../api/effects/queries/Questionnaire/useFetchQuestionnaire";
import { WarningModal } from "../../../components/WarningModal";
import { LoadingOverlay } from "../../../components/LoadingOverlay";
import {
  AddJawabanQuestionnairePayload,
  QuestionnaireResponse,
} from "../../../models/Questionnaire";
import { Profile } from "../../../models/User";
import ProfileState from "../../../recoil/ProfileState";
const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  width: "100%",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  [theme.breakpoints.down("sm")]: {
    padding: "10px",
  },
  margin: "1%",
}));

const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
}));

const RootGrid = styled(Grid)(({ theme }) => ({
  paddingTop: "3%",
  width: "80%",
  [theme.breakpoints.down("sm")]: {
    width: "90%",
  },
}));

const FullTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
}));

const RoundedButton = styled(Button)(({ theme }) => ({
  width: "15%",
  [theme.breakpoints.down("sm")]: {
    width: "30%",
  },
  borderRadius: "90px",
  boxShadow: "none",
}));

const BaseGrid = styled(Grid)(({ theme }) => ({
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  [theme.breakpoints.down("sm")]: {
    backgroundSize: "cover",
  },
}));

export default function QuestionnairePage() {
  const { data: QuestionnaireData, isSuccess, isLoading } = useFetchQuestionnaire();

  const [questionnaireState, setQuestionnaireState] = useState<
    QuestionnaireResponse[]
  >([]);

  // const [innit, setInnit] = useState(true);

  useEffect(() => {
    if (QuestionnaireData && questionnaireState.length === 0) {
      setQuestionnaireState(QuestionnaireData);
    }
  }, [QuestionnaireData, questionnaireState.length]);

  const [warningModalState, setWarningModalState] = useState(false);
  const [warningModalText, setWarningModalText] = useState("");

  const { mutateAsync: AddJawabanQuestionnaire } = useAddJawabanQuestionnaire({
    onSuccess() {
      setWarningModalText("Pengisian Questionnaire Success");
      setWarningModalState(true);
    },
    onError() {
      setWarningModalText("Pengisian Questionnaire Error");
      setWarningModalState(true);
    },
  });

  const handleJawaban = (jawaban: AddJawabanQuestionnairePayload) => {
    var tempQuestionnaireState = [...questionnaireState];
    tempQuestionnaireState[
      Number(
        tempQuestionnaireState.findIndex(
          (e) => e.PERTANYAAN_ID === jawaban.PERTANYAAN_ID
        )
      )
    ] = {
      PERTANYAAN_ID: jawaban.PERTANYAAN_ID,
      PERTANYAAN: jawaban.PERTANYAAN,
      TIPE_PERTANYAAN: jawaban.TIPE_PERTANYAAN,
      JAWABAN: jawaban.JAWABAN,
      PENJELASAN: jawaban.JAWABAN ? jawaban.PENJELASAN : "",
    };
    setQuestionnaireState(tempQuestionnaireState);
  };

  const SaveQuestionnaire = () => {
    for (let index = 0; index < questionnaireState.length; index++) {
      if (
        questionnaireState[index].JAWABAN === null ||
        (questionnaireState[index].JAWABAN &&
          questionnaireState[index].PENJELASAN === "")
      ) {
        setWarningModalText(
          `Mohon Isi Pertanyaan "${questionnaireState[index].PERTANYAAN}" Dengan Benar`
        );
        setWarningModalState(true);
        return;
      }
      // if (questionnaireState[index] === undefined) {
      // } else if (
      //   (questionnaireState[index].JAWABAN ||
      //     questionnaireState[index].JAWABAN === null) &&
      //   questionnaireState[index].PENJELASAN === ""
      // ) {
      //   setWarningModalText(
      //     `Mohon Isi Pertanyaan "${questionnaireState[index].PERTANYAAN}" Dengan Benar`
      //   );
      //   setWarningModalState(true);
      //   return;
      // }
    }

    if (questionnaireState !== undefined) {
      AddJawabanQuestionnaire(questionnaireState);
    }
  };

  const recoilValue = useRecoilValue(ProfileState);

  const [profileRecoil, setprofileRecoil] = useState<Profile>();

  useEffect(() => {
    if (recoilValue !== null) {
      setprofileRecoil(recoilValue);
    }
  }, [recoilValue]);

  return (
    <>
      <WarningModal
        open={warningModalState}
        handleClose={() => {
          setWarningModalState(false);
        }}
        text={warningModalText}
      />
      <LoadingOverlay isLoading={isLoading}>
        <BaseGrid container justifyContent="center">
          <Fade in={isSuccess}>
            <RootGrid container justifyContent="center">
              <Grid container justifyContent="center">
                <SquareGrid container>
                  <DescGrid item xs={12} sx={{ textAlign: "center" }}>
                    {profileRecoil?.Questionnaire ? (
                      <span />
                    ) : (
                      <Typography color="error">
                        Mohon untuk menjawab semua pertanyaan dibawah dengan data
                        terbaru
                      </Typography>
                    )}
                  </DescGrid>
                  {questionnaireState.map((value, key) => (
                    <DescGrid
                      container
                      key={key}
                      id={`pertanyaan-${value.PERTANYAAN_ID}`}
                    >
                      <DescGrid item xs={12}>
                        <Typography variant="h6">{value.PERTANYAAN}</Typography>
                      </DescGrid>
                      {value.TIPE_PERTANYAAN === "Essay" ? (
                        <DescGrid item xs={12}>
                          <FullTextField
                            error={value.PENJELASAN === ""}
                            helperText={
                              value.PENJELASAN === ""
                                ? "Mohon Untuk Mengisi Jawaban"
                                : ""
                            }
                            multiline
                            placeholder="Jelaskan"
                            variant="outlined"
                            value={value.PENJELASAN}
                            onChange={(e) => {
                              handleJawaban({
                                PERTANYAAN_ID: value.PERTANYAAN_ID,
                                PERTANYAAN: value.PERTANYAAN,
                                TIPE_PERTANYAAN: value.TIPE_PERTANYAAN,
                                JAWABAN: true,
                                PENJELASAN: e.target.value,
                              });
                            }}
                          />
                        </DescGrid>
                      ) : (
                        <DescGrid item xs={12}>
                          <FormControl>
                            <RadioGroup
                              aria-labelledby="demo-controlled-radio-buttons-group"
                              name="controlled-radio-buttons-group"
                              value={String(value.JAWABAN)}
                              row
                            >
                              <FormControlLabel
                                value={"true"}
                                control={<Radio />}
                                label={<Typography color="black">Iya</Typography>}
                                onClick={() => {
                                  handleJawaban({
                                    PERTANYAAN_ID: value.PERTANYAAN_ID,
                                    PERTANYAAN: value.PERTANYAAN,
                                    TIPE_PERTANYAAN: value.TIPE_PERTANYAAN,
                                    JAWABAN: true,
                                    PENJELASAN: value.PENJELASAN,
                                  });
                                }}
                              />
                              <FormControlLabel
                                value={"false"}
                                control={<Radio />}
                                label={
                                  <Typography color="black">Tidak</Typography>
                                }
                                onClick={() => {
                                  handleJawaban({
                                    PERTANYAAN_ID: value.PERTANYAAN_ID,
                                    PERTANYAAN: value.PERTANYAAN,
                                    TIPE_PERTANYAAN: value.TIPE_PERTANYAAN,
                                    JAWABAN: false,
                                    PENJELASAN: value.PENJELASAN,
                                  });
                                }}
                              />
                            </RadioGroup>
                          </FormControl>
                          <FullTextField
                            disabled={!value.JAWABAN}
                            error={
                              (value.JAWABAN || value.JAWABAN === null) &&
                              value.PENJELASAN === ""
                            }
                            helperText={
                              (value.JAWABAN || value.JAWABAN === null) &&
                                value.PENJELASAN === ""
                                ? "Mohon Untuk Mengisi Jawaban"
                                : ""
                            }
                            multiline
                            placeholder="Apabila memilih 'Iya' sebutkan alasannya"
                            variant="outlined"
                            value={value.PENJELASAN}
                            inputProps={{
                              sx: {
                                "&::placeholder": {
                                  opacity: 0.7,
                                },
                              },
                            }}
                            onChange={(e) => {
                              handleJawaban({
                                PERTANYAAN_ID: value.PERTANYAAN_ID,
                                PERTANYAAN: value.PERTANYAAN,
                                TIPE_PERTANYAAN: value.TIPE_PERTANYAAN,
                                JAWABAN: value.JAWABAN,
                                PENJELASAN: e.target.value,
                              });
                            }}
                          />
                        </DescGrid>
                      )}
                    </DescGrid>
                  ))}
                  <DescGrid container justifyContent="flex-end">
                    <RoundedButton
                      variant="contained"
                      onClick={SaveQuestionnaire}
                    >
                      Save
                    </RoundedButton>
                  </DescGrid>
                </SquareGrid>
              </Grid>
            </RootGrid>
          </Fade>
        </BaseGrid>
      </LoadingOverlay>
    </>
  );
}
